/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. It estimates principal and interest only. Property taxes, insurance, and fees on a mortgage are extra and vary by lender.`)
};

const es_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Estima solo el principal e interés. Los impuestos sobre la propiedad, seguros y tarifas en una hipoteca son adicionales y varían según el prestamista.`)
};

const de_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Es werden nur Tilgung und Zinsen berechnet. Grundsteuer, Versicherungen und Gebühren bei einer Hypothek kommen zusätzlich hinzu und variieren je nach Kreditgeber.`)
};

const nl_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Het schat alleen kapitaal en rente. Onroerendgoedbelasting, verzekeringen en vergoedingen op een hypotheek zijn extra en variëren per lender.`)
};

const fr_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Il estime uniquement le principal et les intérêts. Les impôts fonciers, l'assurance et les frais sur une hypothèque sont supplémentaires et varient selon le prêteur.`)
};

const it_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Stima solo il capitale e gli interessi. Le tasse sulla proprietà, l'assicurazione e le commissioni su un mutuo sono extra e variano a seconda del prestatore.`)
};

const pt_br2_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Estima apenas principal e juros. Impostos sobre propriedade, seguro e taxas de hipoteca são extras e variam de acordo com o credor.`)
};

const pt_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Estima apenas capital e juros. Impostos sobre a propriedade, seguros e taxas de hipoteca são extras e variam consoante o credor.`)
};

const ja_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「いいえ。元本と利息のみを推定します。モーゲージの固定資産税、保険、手数料は追加であり、貸し手によって異なります。」`)
};

const zh_ln_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不包含。计算仅估算本金和利息。房贷的房产税、保险和手续费属于额外费用，且因贷款机构而异。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_faq2_a", locale)
	if (locale === "en") return en_ln_faq2_a(inputs)
	if (locale === "es") return es_ln_faq2_a(inputs)
	if (locale === "de") return de_ln_faq2_a(inputs)
	if (locale === "nl") return nl_ln_faq2_a(inputs)
	if (locale === "fr") return fr_ln_faq2_a(inputs)
	if (locale === "it") return it_ln_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ln_faq2_a(inputs)
	if (locale === "pt") return pt_ln_faq2_a(inputs)
	if (locale === "ja") return ja_ln_faq2_a(inputs)
	return zh_ln_faq2_a(inputs)
};